import React from "react";

import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
} from "@mui/material";
import Typography from "../Typography";
import { useMoreOptionsPopoverV2 } from "./hooks/useMoreOptionsPopoverV2";

import { ReactComponent as IconMore } from "../../build/images/attendanceIcons/more.svg";

import "./more-options-popover-v2.styles.css";

const MoreOptionsPopoverV2 = ({ itemSelected, onSelect, options }) => {
  const { open, anchorRef, handleToggle, handleClose, handleListKeyDown } =
    useMoreOptionsPopoverV2();

  return (
    <Stack direction="row" spacing={2} className="more-options-popover-v2">
      <div className="more-options-popover-v2__container">
        <button
          className="more-options-popover-v2__container__button"
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <IconMore />
        </button>
        <Popper
          className="more-options-popover-v2__container__popper"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="more-options-popover-v2__container__menu-list"
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {options.map((option, index) => {
                      return (
                        <MenuItem
                          key={`option-menu-item--${index}`}
                          className={`more-options-popover-v2__container__menu-list__item ${
                            Boolean(itemSelected) &&
                            itemSelected.id === option.id
                              ? "active"
                              : ""
                          }`}
                          onClick={(event) => {
                            onSelect(option);
                            handleClose(event);
                          }}
                        >
                          <div className="more-options-popover-v2__container__menu-list__content">
                            {option.icon}
                            <Typography.H5 weight={500} color={"gray-180"}>
                              {option.label}
                            </Typography.H5>
                          </div>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
};

export default MoreOptionsPopoverV2;
